import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";
import ArtistCard from "./ArtistCard";

const SearchPage = () => {
  const { t, lang } = useApp();
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [artists, setArtists] = useState([]);
  const [events, setEvents] = useState([]);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (!q.trim()) { setStatus("idle"); setArtists([]); setEvents([]); return; }
    setStatus("loading");
    Promise.all([
      axios.get(`/api/search?q=${encodeURIComponent(q)}`),
      axios.get(`/api/events`),
    ]).then(([sr, er]) => {
      setArtists(sr.data.results || []);
      const evs = er.data.events || [];
      const ql = q.toLowerCase();
      setEvents(evs.filter(e =>
        (e.title||"").toLowerCase().includes(ql) ||
        (e.titleAr||"").includes(q) ||
        (e.description||"").toLowerCase().includes(ql) ||
        (e.location||"").toLowerCase().includes(ql)
      ));
      setStatus("ready");
    }).catch(() => setStatus("error"));
  }, [q]);

  return (
    <>
      <div className="page-band">
        <div className="container">
          <h1>{t("searchTitle")}</h1>
          {q && <p style={{ margin:0 }}>{t("searchFor")}: <strong>"{q}"</strong></p>}
        </div>
      </div>

      <section className="section container">
        {!q && <div className="empty-state" style={{ color:"var(--muted)" }}>{t("typeToSearch")}</div>}
        {status === "loading" && <div className="empty-state">{t("loading")}</div>}
        {status === "ready" && artists.length === 0 && events.length === 0 && (
          <div className="empty-state">{t("noResults")} "{q}"</div>
        )}

        {status === "ready" && artists.length > 0 && (
          <div style={{ marginBottom:48 }}>
            <h2 className="section-title" style={{ fontSize:"1.5rem", marginBottom:24 }}>
              {t("artistResults")} <span style={{ color:"var(--brand)", fontFamily:"Poppins" }}>({artists.length})</span>
            </h2>
            <div className="artist-grid">
              {artists.map(a => <ArtistCard key={a._id} artist={a} />)}
            </div>
          </div>
        )}

        {status === "ready" && events.length > 0 && (
          <div>
            <h2 className="section-title" style={{ fontSize:"1.5rem", marginBottom:24 }}>
              {t("eventResults")} <span style={{ color:"var(--brand)", fontFamily:"Poppins" }}>({events.length})</span>
            </h2>
            <div style={{ display:"grid", gap:16 }}>
              {events.map((ev, i) => {
                const title = lang==="ar" && ev.titleAr ? ev.titleAr : ev.title;
                const desc  = lang==="ar" && ev.descriptionAr ? ev.descriptionAr : ev.description;
                return (
                  <div key={i} style={{ background:"var(--surface)", border:"1px solid var(--line)",
                                         borderRadius:"var(--radius-sm)", padding:"20px 22px",
                                         boxShadow:"var(--shadow-sm)" }}>
                    <div style={{ color:"var(--brand)", fontWeight:600, fontSize:"0.8rem",
                                   textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}>
                      {ev.category} · {ev.location}
                    </div>
                    <h3 style={{ margin:"0 0 6px", fontSize:"1.1rem" }}>{title}</h3>
                    {desc && <p style={{ margin:0, color:"var(--muted)", fontSize:"0.94rem",
                                         display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden" }}>{desc}</p>}
                  </div>
                );
              })}
            </div>
            <div style={{ marginTop:18 }}>
              <Link className="btn btn-outline" to="/events">{t("viewAll")} {t("events")}</Link>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default SearchPage;
